<template>
  <el-form-item
    :label="label"
    class="route-code"
    :prop="prop"
    :rules="rules"
  >
    <el-select
      v-model="routeCode"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
      :clearable="false"
      :filterable="false"
    >
      <el-option label="" value="" />
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :value="item.value"
      >
        <span style="float: left; color: #8492a6; font-size: 13px">{{ item.value }}</span>
        <span style="float: left; margin-left: 10px">{{ item.label }}</span>
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {},
  model: {
    event: 'change'
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '線別'
    },
    prop: {
      type: String,
      default: 'route_code'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    initialize: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      options: []
    }
  },
  computed: {
    routeCode: {
      get () {
        return this.value
      },
      set (routeCode) {
        this.$emit('change', routeCode)
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'change'))
          }
        }
        return rules
      }
    }
  },
  async mounted () {
    const routeCode = await this.loadCode()
    const routeCodeSet = routeCode.map(function (index, array) {
      return { value: index.code_value, label: index.code_explanation }
    })
    this.options = routeCodeSet
  },
  methods: {
    async loadCode () {
      if (this.initialize) {
        await this.$axios
          .get('/code-master', { params: { code_id: 'ROUTE_CODE' } })
          .then((res) => {
            sessionStorage.setItem('routeCode', JSON.stringify(res.data.list))
          })
          .catch((e) => {
            console.log(e)
          })
      }
      return JSON.parse(sessionStorage.getItem('routeCode'))
    }
  }
}
</script>

<style lang="scss" scoped>
.route-code {
  ::v-deep .el-form-item__content {
    width: 12em;
  }
}
</style>
